import { ApiModule } from '@common/index';
import type { PostGraduatePartExamHasElement } from '../models';

export class PostGraduatePartExamHasElementApi extends ApiModule {
  protected endpoint = '/post-graduate-part-exam-has-element';

  public getMasterData(partExamTemplateId?: number) {
    return this.api.get<any>(`${this.endpoint}/master-data?partExamTemplateId=${partExamTemplateId}`, { params: { partExamTemplateId } });
  }

  public loadPostGraduatePartExamHasElementDetails(id: number) {
    return this.api.get<PostGraduatePartExamHasElement>(`${this.endpoint}?id=${id}`);
  }

  public savePostGraduatePartExamHasElement(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePostGraduatePartExamHasElement(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
